import React from "react";
import { connect } from "react-redux";
import Logo from "../../assets/images/logo-white.png";
import mainHelper, {apiCall} from "../../helpers/MainHelper";
import ReactLoading from "react-loading";
class ForgotPassword extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email:'',
      code:'',
      password:'',
      password_confirmation:'',
      loading:false
    }
  }
  handleChange = (event) => {
    const {name,value} = event.target;
    this.setState(prevState => ({
      ...prevState,
      [name]:value
    }))
  }
  getCode = async (event) => {
    event.preventDefault();
    const sendCodeForm = document.getElementById('sendCodeForm');
    const getCodeForm = document.getElementById('getCodeForm');
    const formHead = document.getElementById('formHead');
    this.setState({loading:true})
    try {
      await apiCall('password-reset-code', 'post', { email: this.state.email });
      formHead.innerHTML = `Lütfen <strong>${this.state.email}</strong> adresine gönderilen kodu giriniz.`;
      getCodeForm.classList.add('d-none');
      sendCodeForm.classList.remove('d-none');
      this.setState({loading:false})
    } catch (error) {
      this.setState({loading:false})
      if (error.response.status === 400){
        console.log('400');
        mainHelper.toastMessage('error',error.response.data.message);

      }
      console.log('Hata:', error);
    }
  }
  sendCode = async (event) => {
    event.preventDefault();
    const changePasswordForm = document.getElementById('changePasswordForm');
    const sendCodeForm = document.getElementById('sendCodeForm');
    const formHead = document.getElementById('formHead');
    this.setState({loading:true})
    try {
      await apiCall('verify-password-reset-code', 'post', { email: this.state.email,code:this.state.code });
      formHead.textContent = "Lütfen yeni şifrenizi oluşturunuz.";
      sendCodeForm.classList.add('d-none');
      changePasswordForm.classList.remove('d-none')
      this.setState({loading:false})
    } catch (error) {
      this.setState({loading:false})
      console.error('Hata:', error);
    }
  }
  changePassword = async (event) => {
    event.preventDefault();
    const changePasswordForm = document.getElementById('changePasswordForm');
    const successForm = document.getElementById('successForm');
    const formHead = document.getElementById('formHead');
    this.setState({loading:true})
    try {
      await apiCall('update-password', 'post', { email: this.state.email,password:this.state.password,password_confirmation:this.state.password_confirmation });
      formHead.textContent = "";
      changePasswordForm.classList.add('d-none');
      successForm.classList.remove('d-none')
      this.setState({loading:false})
    } catch (error) {
      this.setState({loading:false})
      console.error('Hata:', error);
    }
  }
  render() {
    const {loading} = this.state;
    return (
      <div className="theme-cyan">
        <div >
          <div className="vertical-align-wrap">
            <div className="vertical-align-middle auth-main">
              <div className="auth-box">
                <div className="top">
                  <img src={Logo} alt="Servicezone" style={{width: "190px", margin: "10px"}}/>
                </div>
                <div className="card">
                  <div className="header">
                    <p className="lead">Şifre Kurtarma</p>
                  </div>
                  <div className="body">
                    <p id="formHead">Şifrenizi yenilemek için lütfen kayıtlı email adresinizi giriniz.</p>
                    <form id="getCodeForm" onSubmit={this.getCode} className="form-auth-small ng-untouched ng-pristine ng-valid">
                      <div className="form-group">
                        <input name="email" id="email" className="form-control" placeholder="E-mail Adresi" type="email"
                               onChange={this.handleChange}/>
                      </div>
                      {loading ? (
                              <button className="btn btn-outline-primary btn-lg btn-block" disabled={true}
                                      style={{textAlign: "-webkit-center"}}>
                                Lütfen Bekleyin...<ReactLoading type="spin" width={'24px'} height={'24px'}
                                                                color="#268bd2"></ReactLoading>
                              </button>
                          ) :
                          <button className="btn btn-outline-primary btn-lg btn-block" type="submit">
                            Gönder
                          </button>}
                      <div className="bottom">
                        <span className="helper-text"><a href="login">Giriş yap</a></span>
                      </div>
                    </form>
                    <form id="sendCodeForm" onSubmit={this.sendCode} className="form-auth-small ng-untouched ng-pristine ng-valid d-none">
                      <div className="form-group">
                        <input name="code" id="code" className="form-control" placeholder="Kod" type="number"
                               onChange={this.handleChange}/>
                      </div>
                      {loading ? (
                              <button className="btn btn-outline-primary btn-lg btn-block" disabled={true}
                                      style={{textAlign: "-webkit-center"}}>
                                Lütfen Bekleyin...<ReactLoading type="spin" width={'24px'} height={'24px'}
                                                                color="#268bd2"></ReactLoading>
                              </button>
                          ) :
                          <>
                          <button className="btn btn-outline-primary btn-lg btn-block" type="submit">
                            Gönder
                          </button>
                          <div className="form-group">
                          <p>Mail gelmedi mi ? Tekrar
                              <a href="#!" onClick={this.getCode}>
                                Gönder
                              </a>
                            </p>
                          </div>
                          </>
                      }
                    </form>
                    <form id="changePasswordForm" onSubmit={this.changePassword} className="form-auth-small ng-untouched ng-pristine ng-valid d-none">
                      <div className="form-group">
                        <input name="password" id="password" className="form-control" placeholder="Yeni şifre"
                               type="password" onChange={this.handleChange}/>
                      </div>
                      <div className="form-group">
                        <input name="password_confirmation" id="password_confirmation" className="form-control"
                               placeholder="Yeni şifre tekrar" type="password" onChange={this.handleChange}/>
                      </div>
                      {loading ? (
                              <button className="btn btn-outline-primary btn-lg btn-block" disabled={true}
                                      style={{textAlign: "-webkit-center"}}>
                                Lütfen Bekleyin...<ReactLoading type="spin" width={'24px'} height={'24px'}
                                                                color="#268bd2"></ReactLoading>
                              </button>
                          ) :
                          <button className="btn btn-outline-primary btn-lg btn-block" type="submit">
                            Gönder
                          </button>}
                    </form>
                    <form id="successForm" className="form-auth-small ng-untouched ng-pristine ng-valid text-center d-none">
                      <div className="alert alert-success">Şifreniz başarıyla güncellendi.</div>

                      <a href="login" className="btn btn-outline-primary btn-lg">
                        Giriş yap
                      </a>
                    </form>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

ForgotPassword.propTypes = {};

const mapStateToProps = ({ loginReducer }) => ({
});

export default connect(mapStateToProps, {
})(ForgotPassword);
